var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',[_c('b-tab',{attrs:{"title":"Corporate Detail","active":""}},[_c('corporate-detail-tab')],1),_c('b-tab',{attrs:{"title":"Accounting"}},[_c('accounting-tab')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }